
import React from 'react';
import { Category } from '@/types/assessment';
import { Button } from '@/components/ui/button';
import { Plus, BadgeDollarSign } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface CategoryHeaderProps {
  selectedCategory: Category;
  onAddQuestion: (e: React.MouseEvent) => void;
  isMaturityModel: boolean;
}

export function CategoryHeader({ selectedCategory, onAddQuestion, isMaturityModel }: CategoryHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h3 className="text-lg font-medium">
          {selectedCategory.name || 'Unnamed Category'} Questions
        </h3>
        <div className="flex gap-4 mt-1">
          {selectedCategory.questions.length > 0 && (
            <>
              <div className="flex items-center text-xs text-muted-foreground">
                <span className="inline-block w-3 h-3 rounded-full bg-[#F1F0FB] mr-1.5"></span>
                {selectedCategory.questions.filter(q => !q.premium).length} Free
              </div>
              <div className="flex items-center text-xs text-muted-foreground">
                <BadgeDollarSign className="h-3 w-3 text-[#9b87f5] mr-1" />
                {selectedCategory.questions.filter(q => q.premium).length} Premium
              </div>
              {isMaturityModel && (
                <div className="flex items-center text-xs">
                  <Badge variant="secondary" className="bg-purple-100 text-purple-800 text-xs hover:bg-purple-100">
                    {selectedCategory.questions.filter(q => q.answerType === 'maturity').length} Maturity Level
                  </Badge>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <Button 
        type="button"
        onClick={onAddQuestion}
      >
        <Plus className="mr-2" />
        Add Question
      </Button>
    </div>
  );
}
